module.exports = __webpack_public_path__ + "static/assets/img/video1.294da8a2.gif";